/**
 * ZALT Product Form
 *
 * Merges 5-pack and 4-pack products into a unified selector.
 * Handles bundle type, flavor, subscription, gallery, quantity, and buy-now.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Configuration                                                       */
  /* ------------------------------------------------------------------ */

  var SUBSCRIPTION_DISCOUNT = 0.10; // 10 %

  var FLAVOR_CONFIG = {
    'Watermelon':       { color: '#CC5951' },
    'Cool Mint':        { color: '#84ADCF' },
    'Cucumber Citrus':  { color: '#CBD873' },
    'Ginger Lime':      { color: '#F1D26E' }
  };

  /* ------------------------------------------------------------------ */
  /* DOM refs                                                            */
  /* ------------------------------------------------------------------ */

  var jsonEl          = document.querySelector('[data-product-json]');
  if (!jsonEl) return; // not on a product page

  var bundleBtns      = document.querySelectorAll('[data-bundle]');
  var flavorSection   = document.querySelector('[data-flavor-section]');
  var flavorGrid      = document.querySelector('[data-flavor-selector]');
  var varietyInfo     = document.querySelector('[data-variety-info]');
  var subSection      = document.querySelector('[data-subscription-options]');
  var subNote         = document.querySelector('[data-subscription-note]');
  var buyBtn          = document.querySelector('[data-buy-now]');
  var qtyValue        = document.querySelector('[data-qty-value]');
  var qtyMinus        = document.querySelector('[data-qty-minus]');
  var qtyPlus         = document.querySelector('[data-qty-plus]');
  var galleryMain     = document.querySelector('[data-gallery-main]');
  var galleryThumbs   = document.querySelector('[data-gallery-thumbs]');
  var tabBtns         = document.querySelectorAll('[data-tab-btn]');
  var tabPanels       = document.querySelectorAll('[data-tab-panel]');


  /* ------------------------------------------------------------------ */
  /* Parse product data                                                  */
  /* ------------------------------------------------------------------ */

  var raw = JSON.parse(jsonEl.textContent);
  var fivePack = raw.fivePack;
  var fourPack = raw.fourPack || null;
  var flashSale = raw.flashSale || { enabled: false };
  var flashGlobalEnabled = flashSale.enabled === true;
  var flashPercent = flashSale.discountPercent || 20;
  var flashCode = flashSale.discountCode || '';
  var FLASH_FLAVORS = ['Cucumber Citrus', 'Ginger Lime'];

  function isFlashEligible() {
    return flashGlobalEnabled && state.bundle === '5-Pack Sleeve' && FLASH_FLAVORS.indexOf(state.flavor) !== -1;
  }

  var preorder = raw.preorder || { enabled: false };
  var preorderEnabled = preorder.enabled === true;
  var preorderPercent = preorder.discountPercent || 10;
  var preorderCode = preorder.discountCode || '';
  var preorderMessage = preorder.message || 'Sold out — restocking soon! Ships in 1–2 weeks.';

  var preorderNotice    = document.querySelector('[data-preorder-notice]');
  var preorderMsgEl     = document.querySelector('[data-preorder-message]');
  var preorderDiscEl    = document.querySelector('[data-preorder-discount-text]');

  function isPreorderEligible() {
    if (!preorderEnabled) return false;
    var v = currentVariant();
    if (!v) return false;
    var rawVariants = state.bundle === '5-Pack Sleeve' ? fivePack.variants : (fourPack ? fourPack.variants : []);
    var rawV = rawVariants.find(function (rv) { return rv.id === v.id; });
    return rawV && rawV.inventoryQuantity <= 0 && rawV.inventoryPolicy === 'continue';
  }

  var oosNotice = document.querySelector('[data-oos-notice]');

  function isCurrentVariantOOS() {
    var v = currentVariant();
    if (!v) return true;
    var rawVariants = state.bundle === '5-Pack Sleeve' ? fivePack.variants : (fourPack ? fourPack.variants : []);
    var rawV = rawVariants.find(function (rv) { return rv.id === v.id; });
    return rawV && rawV.inventoryQuantity <= 0;
  }

  // Collect unique flavors from 5-pack variants
  var flavors = [];
  fivePack.variants.forEach(function (v) {
    // Options array: first option is usually the flavor for 5-pack
    var flavor = v.options[0];
    if (flavor && flavors.indexOf(flavor) === -1) {
      flavors.push(flavor);
    }
  });

  /* ------------------------------------------------------------------ */
  /* Build unified variant map                                           */
  /* ------------------------------------------------------------------ */

  // Structure: variantMap['5-Pack Sleeve']['Watermelon'] = { id, price, ... }
  var variantMap = {
    '5-Pack Sleeve': {},
    '4-Pack Mixed Flavors': {}
  };

  // 5-pack: each variant maps to one flavor
  fivePack.variants.forEach(function (v) {
    var flavor = v.options[0];
    variantMap['5-Pack Sleeve'][flavor] = {
      id: v.id,
      price: v.price,         // Shopify prices in cents
      available: v.available,
      image: v.image,
      imageAlt: v.imageAlt,
      sellingPlanAllocations: v.sellingPlanAllocations,
      productId: fivePack.id,
      productTitle: fivePack.title,
      title: '5-Pack Sleeve / ' + flavor
    };
  });

  // 4-pack: single base variant, virtual map for every flavor
  if (fourPack && fourPack.variants.length > 0) {
    var base = fourPack.variants[0];
    flavors.forEach(function (flavor) {
      variantMap['4-Pack Mixed Flavors'][flavor] = {
        id: base.id,
        price: base.price,
        available: base.available,
        image: base.image,
        imageAlt: base.imageAlt,
        sellingPlanAllocations: base.sellingPlanAllocations,
        productId: fourPack.id,
        productTitle: fourPack.title,
        title: '4-Pack Mixed Flavors / ' + flavor
      };
    });
  }

  /* ------------------------------------------------------------------ */
  /* Merge images                                                        */
  /* ------------------------------------------------------------------ */

  var allImages = (fivePack.images || []).concat(fourPack ? (fourPack.images || []) : []);

  /* ------------------------------------------------------------------ */
  /* State                                                               */
  /* ------------------------------------------------------------------ */

  var defaultSellingPlan = null;
  var defaultVariant = variantMap['4-Pack Mixed Flavors'] && variantMap['4-Pack Mixed Flavors']['Watermelon'];
  if (defaultVariant && defaultVariant.sellingPlanAllocations && defaultVariant.sellingPlanAllocations.length > 0) {
    defaultSellingPlan = defaultVariant.sellingPlanAllocations[0].sellingPlanId;
  }

  var state = {
    bundle: '4-Pack Mixed Flavors',
    flavor: 'Watermelon',
    sellingPlanId: defaultSellingPlan,
    quantity: 1
  };

  /* ------------------------------------------------------------------ */
  /* Get current variant                                                 */
  /* ------------------------------------------------------------------ */

  function currentVariant() {
    var bundleMap = variantMap[state.bundle];
    return bundleMap ? bundleMap[state.flavor] : null;
  }

  /* ------------------------------------------------------------------ */
  /* Render helpers                                                      */
  /* ------------------------------------------------------------------ */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function cansInBundle() {
    return state.bundle === '5-Pack Sleeve' ? 5 : 4;
  }

  /* ------------------------------------------------------------------ */
  /* Bundle selector                                                     */
  /* ------------------------------------------------------------------ */

  function isBundleOOS(bundleName) {
    var rawVariants = bundleName === '5-Pack Sleeve' ? fivePack.variants : (fourPack ? fourPack.variants : []);
    if (bundleName === '4-Pack Mixed Flavors') {
      return rawVariants.length > 0 && rawVariants[0].inventoryQuantity <= 0;
    }
    return rawVariants.length > 0 && rawVariants.every(function (v) { return v.inventoryQuantity <= 0; });
  }

  function renderBundles() {
    bundleBtns.forEach(function (btn) {
      var val = btn.getAttribute('data-bundle');
      btn.classList.toggle('is-active', val === state.bundle);

      var badge = btn.querySelector('.bundle-btn__badge');
      var oos = isBundleOOS(val);
      if (oos && !preorderEnabled) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'bundle-btn__badge';
          btn.insertBefore(badge, btn.firstChild);
        }
        badge.textContent = 'SOLD OUT';
        badge.style.background = '#991B1B';
      } else if (badge) {
        if (val === '4-Pack Mixed Flavors') {
          badge.textContent = 'POPULAR';
          badge.style.background = '';
        } else {
          badge.remove();
        }
      }
    });

    // Show / hide flavor selector
    if (state.bundle === '4-Pack Mixed Flavors') {
      flavorSection.style.display = 'none';
      varietyInfo.style.display = '';
    } else {
      flavorSection.style.display = '';
      varietyInfo.style.display = 'none';
    }
  }

  bundleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.bundle = btn.getAttribute('data-bundle');
      state.sellingPlanId = null; // reset subscription on bundle change
      renderBundles();
      renderSubscription();
      renderBuyButton();
      updateGallery();
      fireViewItem();
      document.dispatchEvent(new CustomEvent('pdp:flavor-changed', { detail: { flavor: state.bundle === '4-Pack Mixed Flavors' ? 'Variety Pack' : state.flavor } }));
    });
  });

  /* ------------------------------------------------------------------ */
  /* Flavor selector                                                     */
  /* ------------------------------------------------------------------ */

  function buildFlavors() {
    var html = '';
    flavors.forEach(function (flavor) {
      var cfg = FLAVOR_CONFIG[flavor];
      if (!cfg) return;
      html += '<button type="button" class="flavor-btn' + (flavor === state.flavor ? ' is-active' : '') + '" data-flavor="' + flavor + '">';
      html += '  <span class="flavor-btn__dot" style="background:' + cfg.color + ';"></span>';
      html += '  <span class="flavor-btn__name">' + flavor + '</span>';
      html += '</button>';
    });
    flavorGrid.innerHTML = html;

    flavorGrid.querySelectorAll('[data-flavor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.flavor = btn.getAttribute('data-flavor');
        renderFlavors();
        renderSubscription();
        renderBuyButton();
        updateGallery();
        document.dispatchEvent(new CustomEvent('pdp:flavor-changed', { detail: { flavor: state.flavor } }));
        fireViewItem();
      });
    });
  }

  function renderFlavors() {
    flavorGrid.querySelectorAll('[data-flavor]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-flavor') === state.flavor);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Subscription options                                                */
  /* ------------------------------------------------------------------ */

  function renderSubscription() {
    var v = currentVariant();
    var oos = isCurrentVariantOOS();
    if (!v || !v.sellingPlanAllocations || v.sellingPlanAllocations.length === 0 || (oos && !preorderEnabled)) {
      subSection.innerHTML = '';
      subNote.style.display = 'none';
      return;
    }

    var fullPrice = v.price;
    var flashActive = isFlashEligible();
    var preorderActive = !flashActive && isPreorderEligible();
    var discountedPrice = flashActive
      ? Math.round(fullPrice * (1 - flashPercent / 100))
      : preorderActive
        ? Math.round(fullPrice * (1 - preorderPercent / 100))
        : fullPrice;
    var subPrice = Math.round(fullPrice * (1 - SUBSCRIPTION_DISCOUNT));
    var perCan = discountedPrice / cansInBundle();
    var perCanSub = subPrice / cansInBundle();
    var alloc = v.sellingPlanAllocations[0];
    var hasOneTimeDiscount = flashActive || preorderActive;

    var html = '';

    // Subscribe (shown first)
    html += '<div class="subscription-option' + (String(state.sellingPlanId) === String(alloc.sellingPlanId) ? ' is-active' : '') + '" data-sub-option="' + alloc.sellingPlanId + '">';
    html += '  <span class="subscription-option__discount-badge">' + Math.round(SUBSCRIPTION_DISCOUNT * 100) + '% OFF</span>';
    html += '  <div class="subscription-option__row">';
    html += '    <div class="subscription-option__radio"><span class="subscription-option__radio-dot"></span></div>';
    html += '    <div class="subscription-option__label">';
    html += '      <span class="subscription-option__label-text">Subscribe &amp; save</span>';
    html += '      <span class="subscription-option__per-can">&bull; ' + formatMoney(perCanSub) + '/can</span>';
    html += '    </div>';
    html += '    <div style="margin-left:auto;display:flex;align-items:baseline;gap:0.5rem;">';
    html += '      <span class="subscription-option__price">' + formatMoney(subPrice) + '</span>';
    html += '      <span class="subscription-option__original-price">' + formatMoney(fullPrice) + '</span>';
    html += '    </div>';
    html += '  </div>';
    if (String(state.sellingPlanId) === String(alloc.sellingPlanId)) {
      html += '  <div class="subscription-option__benefits">';
      html += '    <div><span class="check">✓</span><span>Never run out - delivered monthly</span></div>';
      html += '    <div><span class="check">✓</span><span>No commitment. Cancel anytime</span></div>';
      html += '  </div>';
    }
    html += '</div>';

    // One-time
    html += '<div class="subscription-option' + (state.sellingPlanId === null ? ' is-active' : '') + '" data-sub-option="one-time">';
    if (flashActive) {
      html += '  <span class="subscription-option__discount-badge" style="background:var(--color-primary);">' + flashPercent + '% OFF — FLASH SALE</span>';
    } else if (preorderActive) {
      html += '  <span class="subscription-option__discount-badge" style="background:#D97706;">' + preorderPercent + '% OFF — RESTOCKING</span>';
    }
    html += '  <div class="subscription-option__row">';
    html += '    <div class="subscription-option__radio"><span class="subscription-option__radio-dot"></span></div>';
    html += '    <div class="subscription-option__label">';
    html += '      <span class="subscription-option__label-text">' + (preorderActive ? 'Order now (restocking)' : 'One-time purchase') + '</span>';
    html += '      <span class="subscription-option__per-can">&bull; ' + formatMoney(perCan) + '/can</span>';
    html += '    </div>';
    if (hasOneTimeDiscount) {
      html += '    <div style="margin-left:auto;display:flex;align-items:baseline;gap:0.5rem;">';
      html += '      <span class="subscription-option__price">' + formatMoney(discountedPrice) + '</span>';
      html += '      <span class="subscription-option__original-price">' + formatMoney(fullPrice) + '</span>';
      html += '    </div>';
    } else {
      html += '    <span class="subscription-option__price">' + formatMoney(fullPrice) + '</span>';
    }
    html += '  </div>';
    html += '</div>';

    subSection.innerHTML = html;

    // Bind clicks
    subSection.querySelectorAll('[data-sub-option]').forEach(function (el) {
      el.addEventListener('click', function () {
        var val = el.getAttribute('data-sub-option');
        state.sellingPlanId = val === 'one-time' ? null : val;
        renderSubscription();
        renderBuyButton();
      });
    });

    subNote.style.display = state.sellingPlanId ? '' : 'none';
  }

  /* ------------------------------------------------------------------ */
  /* Buy Now button                                                      */
  /* ------------------------------------------------------------------ */

  function renderBuyButton() {
    var v = currentVariant();
    var preorder = isPreorderEligible();
    var oos = isCurrentVariantOOS();
    if (v && v.available) {
      if (oos && !preorder) {
        buyBtn.disabled = true;
        buyBtn.textContent = 'Sold Out';
      } else if (preorder) {
        buyBtn.disabled = false;
        buyBtn.textContent = 'Order Now — Ships in 1–2 Weeks';
      } else {
        buyBtn.disabled = false;
        buyBtn.textContent = 'Buy Now';
      }
    } else {
      buyBtn.disabled = true;
      buyBtn.textContent = v ? 'Sold Out' : 'Unavailable';
    }
    renderPreorder();
    renderOOS(oos, preorder);
  }

  function renderOOS(oos, preorder) {
    if (!oosNotice) return;
    oosNotice.style.display = (oos && !preorder) ? '' : 'none';
  }

  function renderPreorder() {
    if (!preorderNotice) return;
    if (isPreorderEligible()) {
      preorderNotice.style.display = '';
      if (preorderMsgEl) preorderMsgEl.textContent = preorderMessage;
      if (preorderDiscEl) preorderDiscEl.textContent = preorderPercent + '%';
    } else {
      preorderNotice.style.display = 'none';
    }
  }

  buyBtn.addEventListener('click', function () {
    var v = currentVariant();
    if (!v || buyBtn.disabled) return;

    buyBtn.disabled = true;
    buyBtn.innerHTML = '<span class="loading-dots"><span></span><span></span><span></span></span>';

    var sellingPlan = state.sellingPlanId ? parseInt(state.sellingPlanId, 10) : null;

    // Track add_to_cart
    trackEvent('add_to_cart', {
      ecommerce: {
        currency: 'USD',
        value: v.price / 100 * state.quantity,
        items: [{
          item_id: v.productId,
          item_name: v.productTitle,
          item_variant: v.title,
          price: v.price / 100,
          quantity: state.quantity
        }]
      }
    });

    // Add to cart then redirect
    var body = {
      id: v.id,
      quantity: state.quantity,
      properties: { _cans: String(cansInBundle()) }
    };
    if (sellingPlan) body.selling_plan = sellingPlan;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Track begin_checkout
        trackEvent('begin_checkout', {
          ecommerce: {
            currency: 'USD',
            value: v.price / 100 * state.quantity,
            items: [{
              item_id: v.productId,
              item_name: v.productTitle,
              item_variant: v.title,
              price: v.price / 100,
              quantity: state.quantity
            }]
          }
        });
        var checkoutUrl = '/checkout';
        if (isFlashEligible() && flashCode && !state.sellingPlanId) {
          checkoutUrl += '?discount=' + encodeURIComponent(flashCode);
        } else if (isPreorderEligible() && preorderCode && !state.sellingPlanId) {
          checkoutUrl += '?discount=' + encodeURIComponent(preorderCode);
        }
        window.location.href = checkoutUrl;
      })
      .catch(function () {
        buyBtn.disabled = false;
        buyBtn.textContent = 'Buy Now';
      });
  });

  /* ------------------------------------------------------------------ */
  /* Quantity selector                                                   */
  /* ------------------------------------------------------------------ */

  qtyMinus.addEventListener('click', function () {
    if (state.quantity > 1) {
      state.quantity--;
      qtyValue.textContent = state.quantity;
    }
  });
  qtyPlus.addEventListener('click', function () {
    state.quantity++;
    qtyValue.textContent = state.quantity;
  });

  /* ------------------------------------------------------------------ */
  /* Info tabs                                                           */
  /* ------------------------------------------------------------------ */

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab-btn');
      tabBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      tabPanels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === target);
      });
    });
  });

  /* ------------------------------------------------------------------ */
  /* Gallery                                                             */
  /* ------------------------------------------------------------------ */

  function getFilteredImages() {
    var bundleType = state.bundle;

    // 4-Pack: show all 4-pack product images
    if (bundleType === '4-Pack Mixed Flavors' && fourPack) {
      return (fourPack.images || []).length > 0 ? fourPack.images : allImages;
    }

    // 5-Pack: show variant image + flavor-matched images (by alt text) + shared images
    var v = currentVariant();
    var flavor = state.flavor;
    var flavorLower = flavor.toLowerCase();
    var productImages = fivePack.images || [];

    // Collect all variant image URLs so we can identify them
    var variantImageUrls = {};
    fivePack.variants.forEach(function (variant) {
      if (variant.image) variantImageUrls[variant.image] = true;
    });

    // Categorize images: flavor-specific (alt text matches) vs shared (no flavor in alt)
    var flavorNames = Object.keys(FLAVOR_CONFIG).map(function (f) { return f.toLowerCase(); });
    var flavorImages = [];
    var sharedImages = [];

    productImages.forEach(function (img) {
      // Skip all variant-assigned images (they duplicate media)
      if (variantImageUrls[img.src]) return;

      var alt = (img.alt || '').toLowerCase();

      // Check if this image's alt text mentions ANY flavor
      var mentionsFlavor = flavorNames.some(function (f) { return alt.indexOf(f) !== -1; });

      if (mentionsFlavor) {
        // Only include if it matches the SELECTED flavor
        if (alt.indexOf(flavorLower) !== -1) {
          flavorImages.push(img);
        }
      } else {
        // No flavor in alt text = shared image, show for all flavors
        sharedImages.push(img);
      }
    });

    // Build final list: variant image first, then flavor images, then shared
    var result = [];
    if (v && v.image) {
      result.push({ src: v.image, thumb: v.image, alt: v.imageAlt || v.title });
    }
    flavorImages.forEach(function (img) { result.push(img); });
    sharedImages.forEach(function (img) { result.push(img); });

    return result.length > 0 ? result : productImages;
  }

  var currentGalleryIndex = 0;

  function updateGallery() {
    var images = getFilteredImages();
    if (images.length === 0) return;

    currentGalleryIndex = 0;
    galleryMain.removeAttribute('srcset');
    galleryMain.removeAttribute('sizes');
    galleryMain.src = images[0].src;
    galleryMain.alt = images[0].alt || 'ZALT Electrolyte Pouches';

    // Build thumbnails
    if (images.length > 1) {
      var html = '';
      images.forEach(function (img, i) {
        html += '<button type="button" class="product-gallery__thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb-idx="' + i + '">';
        html += '  <img src="' + (img.thumb || img.src) + '" alt="' + escapeHtml(img.alt || 'View ' + (i + 1)) + '" width="64" height="64" loading="lazy">';
        html += '</button>';
      });
      galleryThumbs.innerHTML = html;
      galleryThumbs.style.display = '';

      galleryThumbs.querySelectorAll('[data-thumb-idx]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-thumb-idx'), 10);
          currentGalleryIndex = idx;
          galleryMain.src = images[idx].src;
          galleryMain.alt = images[idx].alt || '';
          galleryThumbs.querySelectorAll('.product-gallery__thumb').forEach(function (t, ti) {
            t.classList.toggle('is-active', ti === idx);
          });
        });
      });
    } else {
      galleryThumbs.innerHTML = '';
      galleryThumbs.style.display = 'none';
    }

  }

  /* ------------------------------------------------------------------ */
  /* Analytics                                                           */
  /* ------------------------------------------------------------------ */

  function trackEvent(name, data) {
    if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: name }, data));
    }
  }

  function fireViewItem() {
    var v = currentVariant();
    if (!v) return;
    trackEvent('view_item', {
      ecommerce: {
        currency: 'USD',
        value: v.price / 100,
        items: [{
          item_id: v.productId,
          item_name: v.productTitle,
          item_variant: v.title,
          price: v.price / 100,
          quantity: 1
        }]
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ------------------------------------------------------------------ */
  /* Init                                                                */
  /* ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------ */
  /* URL param overrides (?variant=ID or ?bundle=5-pack&flavor=Name)    */
  /* ------------------------------------------------------------------ */

  (function applyUrlParams() {
    var params = new URLSearchParams(window.location.search);

    // Check for ?variant=ID — find which bundle/flavor it belongs to
    var variantParam = params.get('variant');
    if (variantParam) {
      var vid = parseInt(variantParam, 10);
      var found = false;
      ['5-Pack Sleeve', '4-Pack Mixed Flavors'].forEach(function (bundle) {
        Object.keys(variantMap[bundle]).forEach(function (flavor) {
          if (variantMap[bundle][flavor].id === vid && !found) {
            state.bundle = bundle;
            state.flavor = flavor;
            state.sellingPlanId = null;
            found = true;
          }
        });
      });
    }

    // Check for ?bundle=5-pack&flavor=Name
    var bundleParam = params.get('bundle');
    var flavorParam = params.get('flavor');
    if (bundleParam) {
      if (bundleParam === '5-pack' || bundleParam === '5-Pack Sleeve') {
        state.bundle = '5-Pack Sleeve';
      } else if (bundleParam === '4-pack' || bundleParam === '4-Pack Mixed Flavors') {
        state.bundle = '4-Pack Mixed Flavors';
      }
    }
    if (flavorParam && flavors.indexOf(flavorParam) !== -1) {
      state.flavor = flavorParam;
    }
  })();

  buildFlavors();
  renderBundles();
  renderSubscription();
  renderBuyButton();
  updateGallery();

  // Fire initial view_item
  setTimeout(fireViewItem, 100);

  // Reset the buy-now button's loading state if the page is restored from
  // BFCache (browser back from checkout). Without this, the button stays
  // stuck showing the loading dots.
  var buyBtnIdleHTML = buyBtn ? buyBtn.innerHTML : null;
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !buyBtn || buyBtnIdleHTML == null) return;
    buyBtn.disabled = false;
    buyBtn.innerHTML = buyBtnIdleHTML;
  });

})();
